export default __webpack_public_path__ + "static/media/fron-end-pacifico.f9f59ae4.svg";